module.exports = __webpack_public_path__ + "assets/icon-bars.1c2ed2cb.svg";